import { Logo } from '@components/common/Logo';
import { MobileMenuButton } from '@components/common/MobileMenuButton';
import styles from './Header.module.css';

interface HeaderProps {
  onMenuToggle: () => void;
  isMenuOpen: boolean;
}

export const Header: React.FC<HeaderProps> = ({ onMenuToggle, isMenuOpen }) => {
  return (
    <header className={styles.header}>
      <div className={styles.container}>
        <Logo showText={true} />
        <MobileMenuButton isOpen={isMenuOpen} onClick={onMenuToggle} />
      </div>
    </header>
  );
};
